import { FCompositionTypesEnum, FShallowNode, FShallowNodeTypesEnum } from '../types/index.js';

import { decodeFCompositionId } from './decodeFCompositionId.js';

export const isFArrangementShallowNode = (node: FShallowNode): boolean => {
  return (
    node.type === FShallowNodeTypesEnum.FComposition &&
    decodeFCompositionId(node.id).type === FCompositionTypesEnum.FArrangement
  );
};
